import { action, computed, observable } from 'mobx';

class ErrorStore {
  @observable private errors: string[] = [];

  @computed public get hasErrors() {
    return this.errors.length > 0;
  }

  @action
  public addError(msg: string) {
    this.errors.push(msg);
  }
}

export const errorStore: ErrorStore = new ErrorStore();
